import { render, staticRenderFns } from "./SelectModifiers.vue?vue&type=template&id=fea22c50&"
import script from "./SelectModifiers.vue?vue&type=script&lang=js&"
export * from "./SelectModifiers.vue?vue&type=script&lang=js&"
import style0 from "./SelectModifiers.vue?vue&type=style&index=0&id=fea22c50&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports